import { useHistory } from 'react-router-dom';
import { useClient, useToken } from '@/hooks';

type useLogoutTypes = {
  logout: (setLoading?: React.Dispatch<React.SetStateAction<boolean>>) => void;
};

function useLogout(): useLogoutTypes {
  const client = useClient();
  const { clearAll } = useToken();
  const history = useHistory();

  const logout = async (
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    if (setLoading) setLoading(true);

    await clearAll();
    await client.clearAll();

    setTimeout(() => {
      history.push('/');
      if (setLoading) setLoading(false);
    }, 2000);
  };

  return { logout };
}

export default useLogout;
